import { isPremiumOption } from './isPremium';
export const isDisabled = (currentSide, faceplate) => {
    if (currentSide === 'both') {
        if (isPremiumOption(faceplate.leftOption) || isPremiumOption(faceplate.rightOption)) {
            return true;
        }
    } else if (currentSide === 'left') {
        return !!isPremiumOption(faceplate.leftOption);
    } else if (currentSide === 'right') {
        if (isPremiumOption(faceplate.rightOption)) {
            return true;
        }
    }
    return false;
};
